import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import DialogCover from "../DialogCover";
import { useGetRadiologyResultQuery } from "../../../services/radiologyService";
import RadiologyResultListing from "../../Radiology/resultListing";

function RadiologogyResultListing(props) {
  const { shareDataDetail,selectedChat } = props;
  // const { selectedNote } = useSelector(
  //   ({ providerNote }) => ({
  //     selectedNote: providerNote?.selectedNote,
  //   }),
  //   shallowEqual
  // );
  const { data: radiologyResultList } = useGetRadiologyResultQuery({
    pid: selectedChat?.pid,
    get_results: 1,
    e10x_labs: 0,
  });
  return (
    <div>
      <DialogCover title="Radiology Result" {...shareDataDetail}>
        <RadiologyResultListing
          selectedChat={selectedChat}
          resultList={radiologyResultList}
          from="note_results"
          shareDataDetail={shareDataDetail}
          toggleSelectItem={(data) => {
            shareDataDetail?.setSelectedFiles(data);
          }}
        />
      </DialogCover>
    </div>
  );
}

export default RadiologogyResultListing;
